import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import {
  AssignSubGroupClubPayload,
  Group,
  ManageGroupPayload,
  ManageSubGroupClubStatusPayload,
  ManageSubGroupClubStatusResponse,
  ManageSubGroupPayload,
  UpdateGroupStatusPayload,
  UpdateSubGroupStatusPayload,
  UpdateSubGroupStatusResponse,
} from './groupsManagement.types';

const manageGroup = (client: AxiosInstance) => async (payload: ManageGroupPayload) => {
  return (await client.post<{ message: string; data: Group }>(API_ROUTES.MANAGE_GROUP, payload)).data;
};

const manageSubGroup = (client: AxiosInstance) => async (payload: ManageSubGroupPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.MANAGE_SUB_GROUP, payload)).data;
};

const updateGroupStatus = (client: AxiosInstance) => async (payload: UpdateGroupStatusPayload) => {
  return (await client.post<{ message: string; data: Group }>(API_ROUTES.UPDATE_GROUP_STATUS, payload)).data;
};

const assignSubGroupClub = (client: AxiosInstance) => async (payload: AssignSubGroupClubPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ASSIGN_SUB_GROUP_CLUB, payload)).data;
};

const manageSubGroupClubStatus = (client: AxiosInstance) => async (payload: ManageSubGroupClubStatusPayload) => {
  return (await client.post<ManageSubGroupClubStatusResponse>(API_ROUTES.MANAGE_SUB_GROUP_CLUB_STATUS, payload)).data;
};

const updateSubGroupStatus = (client: AxiosInstance) => async (payload: UpdateSubGroupStatusPayload) => {
  return (await client.post<UpdateSubGroupStatusResponse>(API_ROUTES.UPDATE_SUB_GROUP_STATUS, payload)).data;
};

export const groupManagementMutations = {
  manageGroup,
  manageSubGroup,
  assignSubGroupClub,
  manageSubGroupClubStatus,
  updateSubGroupStatus,
  updateGroupStatus,
};
